import React from 'react';
import LessonHome from '../LessonHome';

const Lesson9 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson9;